import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import CeoMessageMain from "./CeoMessageMain";
import Footer from "../../components/Footer";

const CeoMessage = () => {
  return (
    <>
      <HeaderFour />
      <CeoMessageMain />
      <Footer />
    </>
  );
};

export default CeoMessage;
